import { render, staticRenderFns } from "./vFooter.vue?vue&type=template&id=25456b0b&scoped=true&"
import script from "./vFooter.vue?vue&type=script&lang=js&"
export * from "./vFooter.vue?vue&type=script&lang=js&"
import style0 from "./vFooter.vue?vue&type=style&index=0&id=25456b0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25456b0b",
  null
  
)

export default component.exports